<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    methods: {
      logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }
        this.$session.destroy()
        this.$router.push('/login')
      }
    }
  }
</script>

<style>
  @import '../../static/css/customTheme.css';
  @import '../../static/css/customDashboard.css';
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?09ed42cb